import Config from '@app/dev/config/main';

const { registrationFormFiledConfigs } = Config.registrationFormConfigs;

export const credetialFields = [
  {
    name: 'userName',
    fieldName: 'UserName',
    className: 'credential-section',
    enabled: registrationFormFiledConfigs.userName,
    errorMessage: 'Name is not valid',
  },
  {
    name: 'password',
    fieldName: 'Password',
    type: 'password',
    enabled: registrationFormFiledConfigs.password,
    errorMessage: 'Last Name is not valid',
  },
  {
    name: 'confirmPassword',
    fieldName: 'Confirm Password',
    type: 'password',
    enabled: registrationFormFiledConfigs.confirmPassword,
    errorMessage: 'Email is not valid',
  },
];
